import camelCase from 'lodash.camelcase';

/**
 * model.ContactFirstName => contactFirstName
 */
export function normalizeModelValidationErrors(modelState = {}) {
    return Object.keys(modelState)
        .reduce((err, item) => {
            const field = item.split('.')[1];

            err[camelCase(field)] = modelState[item][0];

            return err;
        }, {});
}

export function removeEmptyProperties(values) {
    return Object.keys(values)
        .reduce((filteredValues, field) => {
            if (values[field] !== null) {
                filteredValues[field] = values[field];
            }

            return filteredValues;
        }, {});
}

export function normalizeTypes(values) {
    return Object.keys(values).reduce((newValues, key) => {
        switch (true) {
            case values[key] === null:
                return newValues;
            case /^\d$/.test(values[key].toString()):
                newValues[key] = Number(values[key]);
                break;
            case /^(false|true)$/.test(values[key].toString()):
                newValues[key] = values[key].toString() === 'true';
                break;
            default:
                newValues[key] = values[key];
        }

        return newValues;
    }, {});
}



// WEBPACK FOOTER //
// ./src/services/api/helpers.js